module.exports = __webpack_public_path__ + "media/img/decorations/decoration-right-img-c467e8b79b806a395e6d0cd4388e9502.svg";